import classNames from 'classnames/bind';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import styles from './NewForm.module.scss';

import actions from '@/actions';
import { PrimaryButton } from '@/components/ui/kit/Button';
import Select from '@/components/ui/kit/Select';
import { modalManager } from '@/libs/ModalContainer';
import { NotifierService as notifier } from '@/libs/Notifier';

const cx = classNames.bind(styles);

const NewForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [specs, setSpecs] = useState({
    protocol: 'mavlink',
    firmware: '',
    frame: '',
  });

  const handleChange = (e) => {
    const nextSpecs = { ...specs };

    switch (e.target.name) {
      case 'protocol':
        nextSpecs.protocol = e.target.value;
        nextSpecs.firmware = '';
        nextSpecs.frame = '';
        break;

      case 'firmware':
        nextSpecs.firmware = e.target.value;
        nextSpecs.frame = '';
        break;

      case 'frame':
        nextSpecs.frame = e.target.value;
        break;

      default:
        break;
    }

    setSpecs(nextSpecs);
  };

  const doOK = () => {
    if (!specs.firmware) {
      notifier.error('Please select a firmware.');
      return;
    }
    if (!specs.frame) {
      notifier.error('Please select a frame.');
      return;
    }

    dispatch(actions.mission.setSpecs(specs));

    navigate('/mission-hub/new');
    modalManager.hide();
  };

  return (
    <div className={cx('container')}>
      <div className={cx('content')}>
        <Select name="protocol" value={specs.protocol} onChange={handleChange}>
          <option value="mavlink">MavLink</option>
        </Select>
        <Select name="firmware" value={specs.firmware} onChange={handleChange}>
          <option value="ardupilot">ArduPilot</option>
          <option value="px4">PX4</option>
        </Select>
        <Select name="frame" value={specs.frame} onChange={handleChange} disabled={specs.firmware === ''}>
          {specs.firmware === 'ardupilot' && <option value="copter">Copter</option>}
          {specs.firmware === 'ardupilot' && <option value="vtol">Plane (VTOL)</option>}
          {specs.firmware === 'px4' && <option value="rover">Rover</option>}
        </Select>
      </div>
      <PrimaryButton text="OK" accent center onClick={doOK} />
    </div>
  );
};

export default NewForm;
